// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UsageDoorTimesResponse implements flatbuffers.IUnpackableObject<UsageDoorTimesResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageDoorTimesResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageDoorTimesResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDoorTimesResponse,
  ): UsageDoorTimesResponse {
    return (obj || new UsageDoorTimesResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsUsageDoorTimesResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDoorTimesResponse,
  ): UsageDoorTimesResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageDoorTimesResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  liftName(): string;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  dwell(): string;
  dwell(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  dwell(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  open(): string;
  open(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  open(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  close(): string;
  close(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  close(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  lobbydwell(): string;
  lobbydwell(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  lobbydwell(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startUsageDoorTimesResponse(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, liftNameOffset, 0);
  }

  static addDwell(builder: flatbuffers.Builder, dwellOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dwellOffset, 0);
  }

  static addOpen(builder: flatbuffers.Builder, openOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, openOffset, 0);
  }

  static addClose(builder: flatbuffers.Builder, closeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, closeOffset, 0);
  }

  static addLobbydwell(builder: flatbuffers.Builder, lobbydwellOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, lobbydwellOffset, 0);
  }

  static endUsageDoorTimesResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // lift_name
    builder.requiredField(offset, 6); // dwell
    builder.requiredField(offset, 8); // open
    builder.requiredField(offset, 10); // close
    builder.requiredField(offset, 12); // lobbydwell
    return offset;
  }

  static createUsageDoorTimesResponse(
    builder: flatbuffers.Builder,
    liftNameOffset: flatbuffers.Offset,
    dwellOffset: flatbuffers.Offset,
    openOffset: flatbuffers.Offset,
    closeOffset: flatbuffers.Offset,
    lobbydwellOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    UsageDoorTimesResponse.startUsageDoorTimesResponse(builder);
    UsageDoorTimesResponse.addLiftName(builder, liftNameOffset);
    UsageDoorTimesResponse.addDwell(builder, dwellOffset);
    UsageDoorTimesResponse.addOpen(builder, openOffset);
    UsageDoorTimesResponse.addClose(builder, closeOffset);
    UsageDoorTimesResponse.addLobbydwell(builder, lobbydwellOffset);
    return UsageDoorTimesResponse.endUsageDoorTimesResponse(builder);
  }

  unpack(): UsageDoorTimesResponseT {
    return new UsageDoorTimesResponseT(
      this.liftName(),
      this.dwell(),
      this.open(),
      this.close(),
      this.lobbydwell(),
    );
  }

  unpackTo(_o: UsageDoorTimesResponseT): void {
    _o.liftName = this.liftName();
    _o.dwell = this.dwell();
    _o.open = this.open();
    _o.close = this.close();
    _o.lobbydwell = this.lobbydwell();
  }

  unpackFields(...fields: string[]): UsageDoorTimesResponseT {
    const t = new UsageDoorTimesResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("dwell")) {
      t.dwell = this.dwell();
    }
    if (fieldSet.has("open")) {
      t.open = this.open();
    }
    if (fieldSet.has("close")) {
      t.close = this.close();
    }
    if (fieldSet.has("lobbydwell")) {
      t.lobbydwell = this.lobbydwell();
    }
    return t;
  }
}

export class UsageDoorTimesResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public liftName: string | Uint8Array | null = null,
    public dwell: string | Uint8Array | null = null,
    public open: string | Uint8Array | null = null,
    public close: string | Uint8Array | null = null,
    public lobbydwell: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.liftName === null || this.liftName === undefined) {
      throw new Error('Required field "lift_name" is not set');
    }
    if (this.dwell === null || this.dwell === undefined) {
      throw new Error('Required field "dwell" is not set');
    }
    if (this.open === null || this.open === undefined) {
      throw new Error('Required field "open" is not set');
    }
    if (this.close === null || this.close === undefined) {
      throw new Error('Required field "close" is not set');
    }
    if (this.lobbydwell === null || this.lobbydwell === undefined) {
      throw new Error('Required field "lobbydwell" is not set');
    }
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const dwell = this.dwell !== null ? builder.createString(this.dwell!) : 0;
    const open = this.open !== null ? builder.createString(this.open!) : 0;
    const close = this.close !== null ? builder.createString(this.close!) : 0;
    const lobbydwell = this.lobbydwell !== null ? builder.createString(this.lobbydwell!) : 0;

    return UsageDoorTimesResponse.createUsageDoorTimesResponse(
      builder,
      liftName,
      dwell,
      open,
      close,
      lobbydwell,
    );
  }

  clone(): UsageDoorTimesResponseT {
    const obj = new UsageDoorTimesResponseT();
    obj.liftName = this.liftName;
    obj.dwell = this.dwell;
    obj.open = this.open;
    obj.close = this.close;
    obj.lobbydwell = this.lobbydwell;
    return obj;
  }

  equals(other: UsageDoorTimesResponseT): boolean {
    if (this.liftName !== other.liftName) return false;
    if (this.dwell !== other.dwell) return false;
    if (this.open !== other.open) return false;
    if (this.close !== other.close) return false;
    if (this.lobbydwell !== other.lobbydwell) return false;
    return true;
  }
}

export function verifyUsageDoorTimesResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "lift_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "dwell");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "open");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "close");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "lobbydwell");
  } finally {
    verifier.popDepth();
  }
}
